<qpx-preview-pane-buttons [choices]="choices()" />
